import React from 'react';
import './style.scss';
import { Spinner, Table } from 'react-bootstrap';
import { Delete as DeleteIcon, Pencil as PencilIcon } from '../../../../components/atoms/icons';
import Modal from '../../../../components/organisms/modals';
import useDetailUser from './hooks';
import { successUpdateMsg } from '../../../../components/atoms/const';
import Button from '../../../../components/molecules/buttons';
import RenderHeader from './RenderHeader';

function DetailUser() {
  const {
    userById, resultUpdate, loadingDeleteUser, handleDeleteUser, afterDeleteUser,
    userListLoad, onNavigationBack, onNavigationToEditUser, currentScreen,
  } = useDetailUser();

  const renderModalBodyDelete = ():string => {
    if (!resultUpdate) return 'Are you sure to remove this user?';
    return successUpdateMsg.SUCCESS_DELETE_USER_MSG;
  };

  const renderModalBodyRestore = ():string => {
    if (!resultUpdate) return 'Are you sure to restore this user?';
    return successUpdateMsg.SUCCESS_RESTORE_USER_MSG;
  };

  return (
    <div className="user-management-container">
      <div className="p-4 px-xl-5 pb-0">
        <RenderHeader
          onNavigateBack={onNavigationBack}
          userById={userById}
          currentScreen={currentScreen}
        />
        <div className="container-detail-user">
          <div className="content-detail">
            <div className="fz-16 fw-bold ms-2 mb-2 mt-2">
              User Details
            </div>
          </div>
          <div className="content-detail">
            <div className="table-detail-content">
              <Table borderless responsive>
                <thead>
                  <tr className="table-border-bottom">
                    <th><div className="fz-14">USER NAME</div></th>
                    <th><div className="fz-14">PHONE NUMBER</div></th>
                    <th><div className="fz-14">EMAIL ADDRESS</div></th>
                    <th><div className="fz-14">POSITION</div></th>
                    <th><div className="fz-14">ROLE</div></th>
                    <th><div className="fz-14 text-center">ACTIONS</div></th>
                  </tr>
                </thead>
                {userById ? (
                  <tbody>
                    <tr>
                      <td>
                        <div className="d-flex cell-tbody-user-item justify-content-start">
                          <div className="icon-container me-2">
                            <div className="icon-name">
                              {userById.firstname.slice(0, 1)}
                            </div>
                          </div>
                          <span><div className="fz-16 mt-3">{`${userById.firstname} ${userById.lastname}` ?? '-'}</div></span>
                        </div>
                      </td>
                      <td>
                        <div className="cell-tbody-user-item fz-14 mt-3" />
                        {userById?.phoneNumber ?? '-'}
                      </td>
                      <td>
                        <div className="cell-tbody-user-item fz-14 mt-3" />
                        {userById?.username ?? '-'}
                      </td>
                      <td>
                        <div className="cell-tbody-user-item fz-14 mt-3" />
                        {userById?.position ?? '-'}
                      </td>
                      <td>
                        <div className="cell-tbody-user-item fz-14 mt-3 text-center" />
                        -
                      </td>
                      <td>
                        {currentScreen === 'active' ? (
                          <div className="cell-tbody-user-item mt-3 d-flex justify-content-evenly">
                            <Modal.Default
                              cancelLabel="No"
                              submitLabel="Yes"
                              title="Delete User"
                              body={renderModalBodyDelete()}
                              isLoading={loadingDeleteUser}
                              result={resultUpdate}
                              onAfterResult={afterDeleteUser}
                              onSubmit={() => handleDeleteUser(userById.id.toString())}
                              size="sm"
                            >
                              <DeleteIcon width={20} />
                            </Modal.Default>
                            <button
                              type="button"
                              className="border-0 bg-transparent"
                              onClick={() => onNavigationToEditUser(userById.id.toString())}
                            >
                              <div style={{ marginTop: '2px' }}>
                                <PencilIcon width={20} />
                              </div>
                            </button>
                          </div>
                        ) : (
                          <div className="cell-tbody-user-item mt-1 d-flex justify-content-center">
                            <Modal.Default
                              cancelLabel="No"
                              submitLabel="Yes"
                              title="Restore User"
                              body={renderModalBodyRestore()}
                              size="sm"
                            >
                              <Button.Default
                                id="restore"
                                isButton={false}
                                label="Restore"
                                disabled
                                outline
                                className="px-3"
                              />
                            </Modal.Default>
                          </div>
                        )}
                      </td>
                    </tr>
                  </tbody>
                ) : (
                  <tbody>
                    <tr>
                      <td colSpan={9}>
                        <div className="d-flex justify-content-center my-2">
                          <div className={!userListLoad ? '' : 'd-none'}>Data Not Found</div>
                          <Spinner className={userListLoad ? 'fz-14' : 'd-none'} animation="border" size="sm" />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                )}
              </Table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DetailUser;
